import { yupResolver } from '@hookform/resolvers/yup';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Card, Grid, Stack } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { getWorkspaceInvitationsForSuperAdmin, IWorkspace } from 'wisestep-api';
import {
  WsColors,
  SearchBar,
  WsCard,
  CardVariant,
  WsListingLoader,
  WsButton,
  WsTitleBanner,
} from 'wisestep-base';
import { object, string } from 'yup';

import TotalInvitesListAdmin from './components/TotalInvitesListAdmin';

const UsersPageAdmin = () => {
  const [invitedUsers, setInvitedUsers] = useState<IWorkspace[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<boolean>(false);

  const schema = object().shape({
    invitesSearch: string().email('Not an email'),
  });

  const defaultValues = {
    invitesSearch: '',
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValues,
  });

  interface IInviteSearchData {
    invitesSearch: string;
  }

  const handleSearchInvites = async (data: IInviteSearchData) => {
    if (data.invitesSearch !== '') {
      try {
        setLoading(true);
        const response = await getWorkspaceInvitationsForSuperAdmin(data.invitesSearch);
        setInvitedUsers(!isEmpty(response.data) ? response.data : []);
        !isEmpty(response.data) ? setSearch(true) : setSearch(false);
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    }
  };

  const clearAllFields = () => {
    methods.reset();
    setInvitedUsers([]);
  };

  return (
    <Box>
      <WsTitleBanner title={'User management'} />
      {!isLoading ? (
        <>
          <FormProvider {...methods}>
            <Box bgcolor={WsColors.White} borderRadius={1} px={2} py={0} mb={4}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={2}
                my={2}
                component="form"
                onSubmit={methods.handleSubmit(handleSearchInvites)}
              >
                <Grid item xs={9.5} pt={2}>
                  <Card sx={{ p: 0.5 }}>
                    <SearchBar placeholder="Search for a user" name="invitesSearch" />
                  </Card>
                </Grid>
                <Grid item xs={3} pt={2}>
                  <Stack direction={'row'} spacing={1} justifyContent="end">
                    <WsButton
                      className="clear-tags"
                      variant="outlined"
                      size="large"
                      type="reset"
                      onClick={clearAllFields}
                    >
                      Clear
                    </WsButton>
                    <WsButton
                      variant="outlined"
                      size="large"
                      type="submit"
                      startIcon={<SearchIcon />}
                    >
                      Search
                    </WsButton>
                  </Stack>
                </Grid>
              </Stack>
            </Box>
          </FormProvider>
          <Box>
            {isEmpty(invitedUsers) && invitedUsers.length === 0 ? (
              <>
                {!search ? (
                  <WsCard
                    title="No Records found"
                    description="We didn't find any results matching your query. Please change your search and try again."
                    cardType={CardVariant.WITH_OUT_BG}
                    isButton={false}
                  />
                ) : (
                  <WsCard
                    title="Search user database with user email"
                    cardType={CardVariant.WITH_OUT_BG}
                    isButton={false}
                  />
                )}
              </>
            ) : (
              <TotalInvitesListAdmin
                invitedUsers={invitedUsers}
                setInvitedUsers={setInvitedUsers}
              />
            )}
          </Box>
        </>
      ) : (
        <WsListingLoader />
      )}
    </Box>
  );
};

export default UsersPageAdmin;
